import React from 'react'
import styled from 'styled-components'
import { Moment } from 'moment-timezone'

import AlertEventTime from 'pages/shared/AlertsHistory/AlertEventTime'
import CollapsiblePanel from 'components/CollapsiblePanel'

import Details from 'pages/shared/Alert/Details'

import { Alert } from 'types/Alert'
import { color } from 'styles/colors'

import { screenSize } from 'styles/shared'

import {
  alertCodeDisplayValue,
  isSerialIdValid,
  isUnitTypeValid
} from 'helpers/alerts'

type Props = {
  alert: Alert
  alertNumber: number
  showDayRthCallback: (day: Moment) => void
  className?: string
}

const AlertCard = ({
  alert,
  alertNumber,
  showDayRthCallback
}: Props) => {
  const {
    problems,
    possibleCauses,
    additionalInfo,
    code,
    unitType = null,
    serialId = null,
    id = '',
    clearedBy
  } = alert

  return (
    <S.CollapsiblePanel
      key={alert.id}
      headerComponent={
        <S.Header>
          <S.Title>
            <S.Img
              src={`/img/${alert.severity.replace('-', '_')}_alert.svg`}
              alt={`${alert.severity} Icon`}
            />
            <S.Description>
              {alertNumber}. {alert.description || '--'}
            </S.Description>
          </S.Title>
          <S.AlertDates>
            <AlertEventTime
              eventOccurredAt={Number(alert.occurredAt)}
              timeZone={alert.timeZone}
              showDayRthCallback={showDayRthCallback}
            />
          </S.AlertDates>
        </S.Header>
      }
    >
      <S.AlertItem key={`${id}-${alertNumber}-${clearedBy}`}>
        <S.HeaderDetail>{alertCodeDisplayValue(code)}</S.HeaderDetail>
        {isUnitTypeValid(unitType, serialId) && <S.HeaderDetail>{unitType}</S.HeaderDetail>}
        {isSerialIdValid(serialId) && <S.HeaderDetail>{serialId}</S.HeaderDetail>}
        <S.DetailsContainer>
          <S.Details {...{ problems, possibleCauses, additionalInfo }} />
        </S.DetailsContainer>
      </S.AlertItem>
    </S.CollapsiblePanel>
  )
}

export default AlertCard

const S = {
  Title: styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
  `,
  Img: styled.img`
    width: 32px;
    height: 32px;
    position: relative;
    top: -3px;
  `,
  Description: styled.div`
    font-weight: 600;
    color: ${color('primaryText')};
    font-size: 16px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 90%;
  `,
  AlertDates: styled.div`
    text-align: left;

    @media ${screenSize.medium} {
      margin-left: 30px;
      text-align: left;
    }

    @media ${screenSize.small} {
      margin-left: 0px;
      text-align: left;
      font-size: 12px;
    }
  `,
  Header: styled.div`
    display: flex;
    padding: 20px 0px;
    align-items: flex-start;
    flex-direction: column;
  `,
  Note: styled.div`
    text-align: center;
    font-style: italic;
    margin: 10px;
    color: ${color('ancillaryText')};
  `,
  AlertItem: styled.div`
    padding: 0 20px;
    margin-bottom: 25px;

    @media ${screenSize.small} {
      padding-left: 10px;
    }
  `,
  CollapsiblePanel: styled(CollapsiblePanel)`
    padding: 0px;
    min-height: 225px;

    @media ${screenSize.small} {
      padding: 0px;
    }

    > div:nth-child(2) {
      display: block !important;
      height: 135px;
      overflow: hidden;
    }
    & > div:first-of-type {
      & > i {
        display: none;
      }
    }
  `,
  HeaderDetail: styled.div`
    color: ${color('primaryText')};
  `,
  DetailsContainer: styled.div`
    padding: 25px 0px;
    @media ${screenSize.small} {
      padding: 10px 0;
    }
  `,
  Details: styled(Details)`
 
    > h4 {
      text-transform: capitalize;
      margin: 0 0 8px 0;
    }
    > ul {
      padding-bottom: 24px;
      &:last-child {
        padding-bottom: 0;
      }
    }
  `
}
